export type Wanderer = { readonly x: number; readonly y: number }

/** What a plot can see of the world. Fields are only ever added, never changed. */
export type Env = {
  readonly weather: string
  /** 0 to 1, how strong this week's weather is. */
  readonly intensity: number
  /** 0 (midnight) to 1 (noon). */
  readonly light: number
  /** Wanderers currently inside this plot, in plot coordinates. */
  readonly here: { readonly cat?: Wanderer }
  /** People looking at this plot right now. */
  readonly visitors: number
  readonly ownerOnline: boolean
}

export const defaultEnv = (overrides: Partial<Env> = {}): Env =>
  Object.freeze({
    weather: 'clear',
    intensity: 0,
    light: 1,
    here: {},
    visitors: 0,
    ownerOnline: false,
    ...overrides,
  })
